import { type ChipProps } from "@mui/material"

import { type UserRole } from "../constants/roles"

const ROLE_COLORS: Record<UserRole, NonNullable<ChipProps["color"]>> = {
  admin: "error",
  doctor: "primary",
  support: "secondary",
  marketing: "default",
  user: "default",
}

export const getRoleColor = (role: string): NonNullable<ChipProps["color"]> =>
  ROLE_COLORS[role as UserRole] ?? "default"

export const truncateId = (id: string, maxLength = 12): string => {
  if (id.length <= maxLength) return id
  return `${id.slice(0, 8)}...${id.slice(-4)}`
}

export const formatDateTime = (
  value: string | Date | undefined | null,
): string => {
  if (!value) return ""
  const date = new Date(value)
  if (isNaN(date.getTime())) return ""
  const dateStr = date.toISOString().split("T")[0]
  const timeStr = date.toTimeString().split(" ")[0]?.slice(0, 5) || ""
  return `${dateStr} ${timeStr}`
}
